export const FETCH_PERMISSIONS = "management/permissions/my";

export const FETCH_ENTITLED_MODULES = "entitlements/all";
